import { show } from 'redux-modal'
import { UPDATE_CANCEL_APPOINTMENT_MODAL_NAME } from './constants'

export const showUpdateCancelInstructionsModal = updateCancelAppointment =>
  show(UPDATE_CANCEL_APPOINTMENT_MODAL_NAME, { updateCancelAppointment })
